var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 12 16"}},_vm.$listeners),[_c('path',{attrs:{"d":"M11.476 7.45a1 1 0 010 1.631l-9.272 6.58a1 1 0 01-1.579-.815V1.686A1 1 0 012.204.87l9.272 6.58z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }